﻿import React, {Component} from 'react';
import PropTypes from "prop-types";
import MemberDetails from "./member-details";

class Member extends Component {
    render() {
        return (
            <MemberDetails/>
        )
    }
}

Member.contextTypes = {
    router: PropTypes.any.isRequired
};

export default Member;